module.exports = __webpack_public_path__ + "img/one_bg.559047f2.jpg";